import { useNavigate } from "react-router-dom";
import { User, BadgeCheck, MapPin, ChevronLeft, ChevronRight } from "lucide-react";
import { useCachedGet } from "@/lib/cache";
import { findEmirate } from "@/lib/constants";
import { useLang } from "@/context/LanguageContext";

export function SellerCard({ sellerId, fallbackName }) {
  const navigate = useNavigate();
  const { lang, dir } = useLang();
  const T = (ar, en) => (lang === "en" ? en : ar);
  const { data: s } = useCachedGet(`/sellers/${sellerId}`, { ads: false }, { enabled: !!sellerId });
  const Chevron = dir === "rtl" ? ChevronLeft : ChevronRight;
  const em = findEmirate(s?.emirate);
  const place = [em ? em[lang === "en" ? "en" : "ar"] : s?.emirate, s?.city].filter(Boolean).join(" · ");
  return (
    <section className="bg-white rounded-3xl border border-[#EFEBE0] p-5" data-testid="seller-card">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-[#DDEAE3] overflow-hidden flex items-center justify-center shrink-0">
          {s?.avatar ? <img src={s.avatar} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" /> : <User className="w-7 h-7 text-[#1A5C3A]" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-bold text-slate-900 truncate" data-testid="seller-name">{s?.name || fallbackName}</p>
            {s?.verified && <span className="flex items-center gap-1 bg-[#EAF5F0] text-[#1A5C3A] text-[11px] font-bold px-2 py-0.5 rounded-full" data-testid="seller-verified"><BadgeCheck className="w-3.5 h-3.5" />{T("موثق", "Verified")}</span>}
          </div>
          {place && <p className="text-sm text-slate-500 flex items-center gap-1 mt-0.5" data-testid="seller-place"><MapPin className="w-3.5 h-3.5" />{place}</p>}
        </div>
      </div>
      <button onClick={() => navigate(`/seller/${sellerId}`)} className="mt-4 w-full flex items-center justify-between text-sm font-semibold text-[#1A5C3A] bg-[#F5F0E8] rounded-xl px-4 h-11" data-testid="seller-all-ads">
        {T("عرض جميع إعلانات البائع", "View all seller's ads")}<Chevron className="w-4 h-4" />
      </button>
    </section>
  );
}
